import { safelyConsoleError } from './safely-console-error';

/**
 * Creates minute dropdown options based on the provided increment and range
 * @param increment - The minute increment (e.g., 15 for 00, 15, 30, 45) - default is 1
 * @param min - The minimum minute value (default is 0)
 * @param max - The maximum minute value (default is 59)
 * @returns Array of dropdown options with value and label
 */
export const createMinuteDropdownOptions = (increment: number = 1, min: number = 0, max: number = 59) => {
	if (increment < 1 || increment > 30) {
		safelyConsoleError(`Invalid minute dropdown increment: ${increment}`);
		return [];
	}

	if (min < 0 || min > 59 || max < 0 || max > 59 || min > max) {
		safelyConsoleError(`Invalid minute dropdown range: min=${min}, max=${max}`);
		return [];
	}

	const minutes: string[] = [];

	// First, generate all incremented values from 0 to 59
	for (let i = 0; i < 60; i += increment) {
		minutes.push(i.toString().padStart(2, '0'));
	}

	// Then filter by min/max range
	const filteredMinutes = minutes.filter((minute) => {
		const minuteNum = +minute;
		return minuteNum >= min && minuteNum <= max;
	});

	return filteredMinutes.map((m) => ({
		value: m,
		label: m,
	}));
};
